import * as React from 'react';
export const jcbSvg = React.forwardRef(function jcbSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.8 12.265c0 .682-.872 1.552-1.6 1.552H0V9.798c.59.165 1.202.248 1.816.248C3.504 10.046 4 9.316 4 8.402V6.059H2.48v2.343c0 .574-.345.993-.96.993A3.19 3.19 0 0 1 0 8.945V4.507C0 3.05.872 2.18 1.6 2.18h3.2v10.085Zm5.6 0c0 .682-.872 1.552-1.6 1.552H5.6V9.395c.464.434 1.264.705 2.56.643a7.286 7.286 0 0 0 1.44-.24v-.853a3.377 3.377 0 0 1-1.384.45c-.984.077-1.584-.458-1.584-1.397 0-.938.6-1.474 1.584-1.388.49.044.963.195 1.384.442v-.861a7.597 7.597 0 0 0-1.44-.233c-1.296-.062-2.096.21-2.56.644V4.507c0-1.458.871-2.326 1.6-2.327h3.2v10.085Zm5.601 0c0 .683-.873 1.552-1.6 1.552h-3.2v-3.88h2.84c.664 0 1.16-.387 1.16-1.008 0-.566-.456-.93-1.048-.97v-.023c.536-.093.832-.481.832-.93 0-.575-.432-.908-1.016-.94l-.184-.007h-2.584V4.507c0-1.458.872-2.327 1.6-2.327H16v10.085Zm-2.72-4.01c.208.054.368.247.368.519 0 .271-.168.473-.368.52l-.128.015h-1.056V8.246h1.056a.713.713 0 0 1 .128.008Zm-.12-1.584c.2.04.368.218.368.482a.483.483 0 0 1-.368.488h-1.064v-.978h.96a.76.76 0 0 1 .104.008Z',
    }),
  );
});
jcbSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var jcb = {
  category: 'paymentmethod',
  colorable: true,
  name: 'jcb',
  svg: jcbSvg,
};
